/**
item: {
    id: 1,
    title: 'Home',
    component: 'Home',
    status: OPEN | MINIMIZED
}
 */
import { defineAsyncComponent, markRaw } from 'vue';
import axios from '@/services/useAxios';
import Components from '@/DarminComponents';

const OPEN = true;
const MINIMIZED = false;

export default {
    namespaced: true,
    state: {
        home: {
            _id: 0,
            id: 0,
            name: 'Home',
            component: 'Home',
            childrens: [],
            params: {},
        },
        menuItems: [],
        windows: new Map(),
    },
    mutations: {
        addWindow(state, item) {
            state.windows.set(item.id, { ...item, status: OPEN });
            // console.log('Item Pushed');
        },
        removeWindow(state, id) {
            state.windows.delete(id);
        },
        minimizedAllWIndows(state) {
            // console.log('state.windows.size', state.windows.size);
            state.windows.forEach((window) => {
                // eslint-disable-next-line no-param-reassign
                window.status = MINIMIZED;
            });
        },
        showWindow(state, item) {
            const window = state.windows.get(item.id);
            if (window) {
                window.status = OPEN;
            }
        },
        setMenuItems(state, items) {
            state.menuItems.splice(0);
            items.map((item) => {
                // console.log(item);
                state.menuItems.push(item);
                return item;
            });
        },
        resetState(state) {
            console.log('resetState');
            state.menuItems.splice(0);
            state.windows.clear();
        },
    },
    actions: {
        print: {
            handler(context, payload) {
                console.log('Action:', payload);
            },
        },
        openWindow: {
            async handler({ state, commit, dispatch }, item) {
                const components = await Components();
                if (state.windows.has(item.id)) {
                    dispatch('showWindow', item);
                } else if (components.getComponent(item.component) !== undefined) {
                    const customComponent = defineAsyncComponent(() => {
                        try {
                            const component = components.getComponent(item.component).load();
                            return component;
                        } catch (error) {
                            return false;
                        }
                    });
                    // console.log(customComponent);
                    if (customComponent) {
                        const customComponentMarkRaw = markRaw(customComponent);
                        // console.log('params:', item.params);
                        commit('minimizedAllWIndows');
                        commit('addWindow', {
                            ...item,
                            app: customComponentMarkRaw,
                            params: item.params,
                        });
                    }
                } else {
                    throw Error();
                }
            },
        },
        showWindow: {
            handler(context, item) {
                context.commit('minimizedAllWIndows');
                context.commit('showWindow', item);
            },
        },
        hideAllWindows: {
            handler(context) {
                context.commit('minimizedAllWIndows');
            },
        },
        closeWindow: {
            handler({ state, commit, dispatch }, item) {
                if (state.windows.has(item.id)) {
                    const windowToClose = state.windows.get(item.id);
                    commit('removeWindow', item.id);
                    if (windowToClose.status) {
                        const windowsArray = Array.from(state.windows.values());
                        if (windowsArray.length > 0) {
                            // Mostrar la última ventana disponible
                            const itemToShow = windowsArray[windowsArray.length - 1];
                            dispatch('showWindow', itemToShow);
                        }
                    }
                    // unMount vue app
                }
            },
        },
        getMenuItems: {
            async handler({ commit }) {
                // commit('setMenuItems', items);
                const res = await axios.get('/menu/tree/profile');
                commit('setMenuItems', res.data);
            },
        },
        openHome: {
            handler({ dispatch, state }) {
                dispatch('openWindow', state.home);
            },
        },
        logout: {
            handler({ commit }) {
                console.log('Logout');
                commit('resetState');
            },
        },
    },
};
